// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"2500a3bb","635":"2500a3bb","911":"ccc7c613"}[chunkId] + ".chunk.css";
};